import { post, get } from '@eika-infrastruktur/request';
import { CONTEXT_PATH } from './index';
const SERVICE_PATH = 'rest/resource/currencies';
export const getCounterValue = (from, to, amount) => {
    const request = {
        from,
        to,
        amount,
    };
    return post(`${CONTEXT_PATH}/${SERVICE_PATH}/countervalue`, request);
};
export function getCurrencies() {
    return get(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VycmVuY3lTZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NlcnZpY2VzL2N1cnJlbmN5U2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxNQUFNLDZCQUE2QixDQUFDO0FBR3hELE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFdkMsTUFBTSxZQUFZLEdBQUcsMEJBQTBCLENBQUM7QUFFaEQsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLENBQUMsSUFBYyxFQUFFLEVBQVksRUFBRSxNQUFjLEVBQW1DLEVBQUU7SUFDN0csTUFBTSxPQUFPLEdBQWdDO1FBQ3pDLElBQUk7UUFDSixFQUFFO1FBQ0YsTUFBTTtLQUNULENBQUM7SUFDRixPQUFPLElBQUksQ0FBeUIsR0FBRyxZQUFZLElBQUksWUFBWSxlQUFlLEVBQUUsT0FBTyxDQUFDLENBQUM7QUFDakcsQ0FBQyxDQUFDO0FBRUYsTUFBTSxVQUFVLGFBQWE7SUFDekIsT0FBTyxHQUFHLENBQWlCLEdBQUcsWUFBWSxJQUFJLFlBQVksRUFBRSxDQUFDLENBQUM7QUFDbEUsQ0FBQyJ9